import { Component } from '@angular/core';
import { forkJoin, EMPTY, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  ClientService,
  SignatureRequestStateName,
  SignatureRequestTypeName,
  SignatureRequestTypeRoute,
  Task,
  TASK_TYPE_NAMES
} from '../../../root/services/client.service';
import { UserService } from '../../../root/services/user.service';
import { Router } from '@angular/router';
import { environment as clientEnvironment } from '../../../../environments/environment';
import { OnboardingService } from '../../../root/services/onboarding.service';

@Component({
  selector: 'hfc-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss']
})
export class DashboardLayoutComponent {
  public TASK_TYPE_NAMES = TASK_TYPE_NAMES;
  public SignatureRequestTypeName = SignatureRequestTypeName;
  public SignatureRequestStateName = SignatureRequestStateName;
  public SignatureRequestStateRoute = SignatureRequestTypeRoute;

  public get user() {
    return this.userService.user;
  }

  public active: Task[] = [];
  public archived: Task[] = [];

  constructor(
    private clientService: ClientService,
    private userService: UserService,
    private router: Router,
    private onboardingService: OnboardingService
  ) {
    this.initialize();
  }

  public async onSignatureRequestClicked(task: Task) {
    const route = task.signatureRequestType ? SignatureRequestTypeRoute.get(task.signatureRequestType) : undefined;
    if (!route) {
      return;
    }

    this.router.navigate([`/signature/${route}`, task.token]);
  }

  public async onArchivedSignatureRequestClicked(task: Task) {
    const attachment = task.declarationFile;
    if (!attachment) {
      return;
    }

    if (attachment.externalURL) {
      window.open(attachment.externalURL);
    } else {
      window.open(`${clientEnvironment.apiUrl}servlet/gcs/${attachment.folder}/${attachment.filename}?download=true`);
    }
  }

  private initialize() {
    // the dashboard is a client-only view (its data API is client-only) - staff who land
    // here (e.g. after a signing flow) are sent to the advisor app before any API call
    if (this.userService.user?.userType !== 'CLIENT') {
      window.location.href = clientEnvironment.adminWebUrl;
      return;
    }

    forkJoin({
      // Only users who have not finished the signup wizard are sent back into it;
      // if the status check fails the dashboard stays usable rather than bouncing anyone
      onboarding: this.onboardingService.getStatus().pipe(catchError(() => of(null))),
      dashboardData: this.clientService.getHomeDashboardDataObservable()
    })
      .pipe(
        catchError((e) => {
          console.error('Dashboard init failed:', e);
          return EMPTY;
        })
      )
      .subscribe(({ onboarding, dashboardData }) => {
        this.active = dashboardData.activeTasks;
        this.archived = dashboardData.archivedTasks;

        if (onboarding && !onboarding.completed) {
          this.router.navigate(['/signup']);
        }
      });
  }
}
